import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quote",
  "use": "icon-quote-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"icon-quote\"><path d=\"M0 50V8.421L8.247 0h7.732v7.105h-4.381L7.99 10.79v12.895h7.99V50H0Zm34.02 0V8.421L42.269 0H50v7.105h-4.381L42.01 10.79v12.895H50V50H34.02Z\" fill=\"#4E5458\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol